import React from "react";

const ArrivalWindowSection = ({ exactTime, deliveryDate , handleUpdateBookingObject }) => {
  const formatDate = (d) => {
    if (d === null || typeof d === "undefined" || d === "")
      return "Not specified";

    const ordinal = (n) => {
      const s = ["th", "st", "nd", "rd"];
      const v = n % 100;
      return s[(v - 20) % 10] || s[v] || s[0];
    };

    const formatFromDate = (dt) => {
      try {
        const weekday = dt.toLocaleDateString(undefined, { weekday: "long" });
        const month = dt.toLocaleDateString(undefined, { month: "long" });
        const day = dt.getDate();
        const year = dt.getFullYear();
        return `${weekday}, ${month} ${day}${ordinal(day)}, ${year}`;
      } catch (e) {
        return dt.toLocaleDateString();
      }
    };

    if (d instanceof Date) return formatFromDate(d);

    try {
      const parsed = new Date(d);
      if (!isNaN(parsed.getTime())) {
        return formatFromDate(parsed);
      }
    } catch (e) {
      // continue to fallback
    }

    let s = String(d).trim();
    s = s.replace(/\sGMT.*$/i, "").trim();
    s = s.replace(/\b\d{1,2}:\d{2}(?::\d{2})?\s*(?:[APap][Mm])?\b/, "").trim();

    try {
      const parsed2 = new Date(s);
      if (!isNaN(parsed2.getTime())) return formatFromDate(parsed2);
    } catch (e) {
      // ignore
    }
    return s;
  };

  const formatTime = (t) => {
    if (t === null || typeof t === "undefined" || t === "")
      return "Not specified";
    const raw = String(t).trim();

    const normalizeSingle = (piece) => {
      let s = String(piece).trim();

      // Remove leading zeros from hour ("02" -> "2")
      s = s.replace(/^0+(?=\d)/, "");

      // Remove ":00" minutes when present (before AM/PM or at end)
      s = s.replace(/:00(?=(\s*[AaPp][Mm])|$)/i, "");

      // Remove spaces before AM/PM so "2 PM" -> "2PM" (matches user's preferred compact form)
      s = s.replace(/\s*(?=[AaPp][Mm]$)/i, "");

      // Uppercase AM/PM if present
      s = s.replace(/([AaPp])([Mm])$/i, (m) => m.toUpperCase());

      return s;
    };

    // If there's an explicit dash range, split on dash
    if (raw.includes("-")) {
      const parts = raw.split("-").map((p) => normalizeSingle(p));
      return parts.filter(Boolean).join(" - ");
    }

    // Otherwise try to extract two time tokens (with AM/PM) from the string
    const tokenRegex = /\d{1,2}(?::\d{2})?\s*[AaPp][Mm]/g;
    const matches = raw.match(tokenRegex);
    if (matches && matches.length >= 2) {
      const parts = matches.slice(0, 2).map((m) => normalizeSingle(m));
      return parts.join(" - ");
    }

    // Fall back to normalizing the whole string
    return normalizeSingle(raw);
  };

  const safeDate = formatDate(deliveryDate);
  const safeTime = formatTime(exactTime);

  return (
    <div className="mb-4">
      <div className="flex gap-x-2 items-center mb-[7px]">
        <img
          src="/images/NewUiIcons/Arrivalwindowicon.svg"
          alt="Arrival window icon"
        />
        <p className="text-[#7876A1] text-[16px] font-bold">Arrival window</p>
        <img
              src="/images/NewUiIcons/Edit.svg"
              alt="edit"
              className="w-[23px] h-[23px] cursor-pointer"
              onClick={()=>handleUpdateBookingObject("tripStatus", "schedule", "EditBookingFromSummaryScheduleArrivalWindow")}
            />
      </div>

      <div className="flex flex-col text-[#211F59] font-semibold pl-[26px]">
        <p>{safeDate}</p>
        <p>{safeTime}</p>
      </div>
    </div>
  );
};

export default ArrivalWindowSection;
